import React, {Component, useState, useEffect} from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Template from "../template/template";
import Up from '../../assets/Up.png';
import Down from '../../assets/Down.png';
import Button from "../../ui/components/buttons/button";

import {Link, useHistory, withRouter} from "react-router-dom";
import formatCurrency from "../../utils/format-currency";

import "./quote-summary.css"
import {_getPolicy, _ratePolicy} from "../../store/policy/service";
import {
    _getSite,
    _getStep,
    _hideModal,
    _hideSpinner,
    _setStep,
    _showModal,
    _showSpinner
} from "../../store/system/service";
import PeopleOutline from "../../assets/PeopleOutline.svg";
import MailOutline from "../../assets/MailOutline.svg";
import Call from "../../assets/Call.svg";
import Email from "../../assets/Email.svg";
import {_gaPushEvent, _gaPushData, _formatAmount} from "../../utils/utility";
import {useTranslation} from "react-i18next";
import {mdDownN} from "../../ui/common";

const SmeHeaderCell = styled.div`
    float: left; 
    padding: 4px 0px;
    vertical-align: bottom;
    font-family: Inter-Medium,Verdana,Arial,sans-serif;
    font-weight: 500;
    letter-spacing: 0px;
    font-size: 12px;
    color: #003da5;
    line-height: 20px;
    
    width: ${props => props.width};
    text-align: ${props => props.align ? props.align : 'left'};
    ${mdDownN`
        position: relative;
        display: inline-block;
        width: auto;
        :first-child::after{
            content:'&';
            margin-left: 5px;
            margin-right: 5px;
        }
    `}
`;

const SmeCell = styled.div`
    float: left; 
    width: ${props => props.width};
    text-align: ${props => props.align ? props.align : 'left'};

    line-height: 37px;
    letter-spacing: 0px;
    font-size: ${props => props.small ? '13px' : '14px'};
    font-family:${props => props.bold ? 'Inter-Medium,Verdana,Arial,sans-serif' : 'Inter-Regular,Verdana,Arial,sans-serif'}; ;
    font-weight: ${props => props.bold ? 'bold' : 'regular'};
    word-wrap: break-word;
    color: #0a1f44;
    ${mdDownN`
        height: 24px;
        text-overflow: ellipsis;
        width: ${props => props.width=="10%"?'10%':'100%'};
        text-align: ${props => props.align ? props.align : 'left'};
        position: ${props => props.width=="10%"?'absolute':'relative'};
        ${props => props.width=="10%"?`
            right: 20px;
        `:''};
        line-height: 24px;
        letter-spacing: ${props => props.width==='40%'?'0.5px':'0'};
        font-size: ${props => props.small ? '13px' : '14px'};
        font-family:${props => props.bold ||  props.mbold ? 'Inter-Semibold,Verdana,Arial,sans-serif' : 'Inter-Regular,Verdana,Arial,sans-serif'}; 
        
        font-weight: ${props => props.bold|| props.mbold ? 'bold' : 'regular'};
        ${props => props.space =='up'?`margin-top: 16px;`:''}
        ${props => props.space =='down'?`margin-bottom: 16px;`:''}
    
        
        
    `}
`;


const QuoteSummary = (props) => {
    const columns = [
        {
            heading: 'Cover',
            width: '50%',
            align: 'left',
            isBold: true
        },
        {
            heading: 'Sum insured / limits (SCG)',
            width: '40%',
            align: 'right',
        },
        {
            heading: '^',
            width: '10%',
            align: 'right',
        },
    ]

    const covers = [
        {
            coverName: 'Property all risks',
            sumInsured: 1050000
        },
        {
            coverName: 'Business interruption',
            sumInsured: 1400
        },
        {
            coverName: 'Money',
            sumInsured: 5000
        },
        {
            coverName: 'Group personal accident',
            sumInsured: 30000
        },
        {
            coverName: 'Liability',
            sumInsured: 5000000
        },
        {
            coverName: 'Work injury compensation',
            sumInsured: 15000000
        },
        {
            coverName: 'Fidelity guarantee',
            sumInsured: 50000
        },
    ]

    const { t, i18n } = useTranslation();

    const [ind, setState] = useState ( {
        propertyAllRisksInd: false,
        businessInterruptionInd: false,
        moneyInd: false,
        groupPersonalAccidentInd: false,
        liabilityInd: false,
        workInjuryCompensationInd: false,
        fidelityGuaranteeInd: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        // Google Analytics
        _gaPushData({
            'pageStep': 'Quote – Result',
            'vPath': '/quote-result',
            'event': 'vpageview'
        });
    }, []);

    const toggleStatus = (field) => {
        setState( {
            ...ind,
            [field]: !ind[field]
        });

        if(!ind[field]){
            if(field === 'propertyAllRisksInd'){
                _gaPushEvent('expandPAR');
            } else if(field === 'businessInterruptionInd') {
                _gaPushEvent('expandBI');
            } else if(field === 'moneyInd') {
                _gaPushEvent('expandMoney');
            } else if(field === 'groupPersonalAccidentInd') {
                _gaPushEvent('expandGPA');
            } else if(field === 'liabilityInd') {
                _gaPushEvent('expandPL');
            } else if(field === 'workInjuryCompensationInd') {
                _gaPushEvent('expandWIC');
            } else if(field === 'fidelityGuaranteeInd') {
                _gaPushEvent('expandFG');
            }
        }
    }

    const openCoverInformation = (event) => {
        _gaPushEvent('AdditionalCoverInformation');
        props.showModal(
            {
                marginTop: '29px',
                icon: MailOutline,
                title: 'Additional Cover Information',
                content:
                    <div className="QuoteSummaryContent">
                        <div className="QuoteSummaryHorLine QuoteSummaryHorLineMobileFirst"/>
                        <div className="QuoteSummaryInfoLine">
                            <div className="QuoteSummaryInfoLineLabel QuoteSummaryInfoLineLabelMobile">
                                Removal of Debris
                            </div>
                            <div className="QuoteSummaryInfoLineValue QuoteSummaryInfoLineValueMobile">
                                {(_formatAmount(
                                    (Number(props.policy.policySME.contentsSI) + Number(props.policy.policySME.buildingSI))*0.1
                                    , i18n.language, t("currency.prefix"))) || '$5,000.00'
                                }

                            </div>
                        </div>

                        <div className="QuoteSummaryHorLine"/>
                        <div className="QuoteSummaryInfoLine">
                            <div className="QuoteSummaryInfoLineLabel QuoteSummaryInfoLineLabelMobile">
                                Architects and Surveyors Fees
                            </div>
                            <div className="QuoteSummaryInfoLineValue QuoteSummaryInfoLineValueMobile">
                                {(_formatAmount(
                                    (Number(props.policy.policySME.contentsSI) + Number(props.policy.policySME.buildingSI))*0.1
                                    , i18n.language, t("currency.prefix"))) || '$5,000.00'
                                }
                            </div>
                        </div>
                        <div className="QuoteSummaryHorLine"/>
                        <div className="QuoteSummaryInfoLine">
                            <div className="QuoteSummaryInfoLineLabel QuoteSummaryInfoLineLabelMobile">
                                Capital Additions
                            </div>
                            <div className="QuoteSummaryInfoLineValue QuoteSummaryInfoLineValueMobile">
                                {(_formatAmount(
                                    (Number(props.policy.policySME.contentsSI) + Number(props.policy.policySME.buildingSI))*0.1
                                    , i18n.language, t("currency.prefix"))) || '$5,000.00'
                                }
                            </div>
                        </div>
                        <div className="QuoteSummaryHorLine"/>
                        <div className="QuoteSummaryInfoLine">
                            <div className="QuoteSummaryInfoLineLabel QuoteSummaryInfoLineLabelMobile">
                                Escalation Clause
                            </div>
                            <div className="QuoteSummaryInfoLineValue QuoteSummaryInfoLineValueMobile">
                                {(_formatAmount(
                                    (Number(props.policy.policySME.contentsSI) + Number(props.policy.policySME.buildingSI))*0.1
                                    , i18n.language, t("currency.prefix"))) || '$5,000.00'
                                }
                            </div>
                        </div>
                        <div className="QuoteSummaryHorLine QuoteSummaryHorLineMobileLast"/>
                    </div>
            }
        )
        _gaPushData({
            'event': 'vpageview',
            'pageStep': 'quote-result-additionalcoverinformation',
            'vPath': '/additionalcoverinformation'
        });
    }

    const openCustomisation = () => {
        _gaPushEvent('ClickHerecustomizedpackage');
        if (props.site === 'bm') {
            props.showModal(
                {
                    icon: PeopleOutline,
                    title: 'Please contact our Brian Mae      Insurance Broker',
                    content:
                        <div>
                            Brian Mae Pte Ltd.
                            <br/>
                            <img src={Call} className="QuoteSizePhone"/> +65 6224 6633 <br/>
                            <img src={Email} className="QuoteSizeEmail"/> SME@brianmae.com
                        </div>,
                    primaryAction: {
                        label: 'Email us',
                        onClick: emailUs
                    },
                    secondaryAction: {
                        label: 'Contact us later',
                        onClick: () => {
                            _gaPushEvent('viewclosecontactuslater');
                            props.hideModal();
                        }
                    }
                }
            )
        }
        else if(props.site === 'mla'){
            props.showModal(
                {
                    marginTop: '23px',
                    icon: PeopleOutline,
                    title: 'Please contact our Multi-Lines Agencies       Insurance Agency',
                    content:
                        <div className="QuoteContent MLA">
                            Multi-Lines Agencies
                            <br/>
                            <div className={'mla-popup'} >
                                <img src={Call} className="QuoteSizePhone" style={{'margin-right':'3px'}}/>
                                + 65 9820 4276 / <br className={'mobileOnlyBr'}/>8499&nbsp;0385&nbsp;/&nbsp;9171&nbsp;1477
                            </div>                            <div className="QuoteContentBufferStyle"></div>
                            <img align="center" src={Email} className="QuoteSizeEmail"/> info@multilines.com.sg
                        </div>,
                    primaryAction: {
                        label: 'Email Us',
                        onClick: emailUs
                    },
                    secondaryAction: {
                        label: 'Contact Us Later',
                        onClick: () => {
                            _gaPushEvent('viewclosecontactuslater');
                            props.hideModal();
                        }
                    }
                }
            )
        }
        else {
            props.showModal(
                {
                    icon: PeopleOutline,
                    title: 'Please contact our g&m      Insurance Broker',
                    content:
                        <div>
                            g&m Pte Ltd.
                            <br/>
                            <img src={Call} className="QuoteSizePhone"/> +65 6576 9855 <br/>
                            <img src={Email} className="QuoteSizeEmail"/> corporate@gnm.com.sg
                        </div>,
                    primaryAction: {
                        label: 'Email us',
                        onClick: emailUs
                    },
                    secondaryAction: {
                        label: 'Contact us later',
                        onClick: () => {
                            _gaPushEvent('viewclosecontactuslater');
                            props.hideModal();
                        }
                    }
                }
            )

        }
    }

    const emailUs = () => {
        _gaPushEvent('viewcloseemail');
        if (props.site === 'bm') {
            window.location = "mailto:SME@brianmae.com";
        }
        else {
            window.location = "mailto:corporate@gnm.com.sg";
        }
    }

    const rows = covers.reduce((acc, cover) => [...acc, [cover.coverName , formatCurrency(cover.sumInsured), '^']], []);

    const applyNow = () => {
        _gaPushEvent('applynow');
        props.history.push((props.site ? '/' + props.site : '') + '/application/uen');
    }

    return (
        <Template simple="Quotation" leftNav step={props.step} policy={props.policy} site={props.site} prevPage="/quote/review">
            <div className="QuoteSummaryTitleGroupStyle">
                <div className="QuoteSummaryTitleStyle">We Insure You</div>
            </div>
            <div className="QuoteSummaryGroupsStyle">
                <div className="QuoteSummaryGroupStyle">
                    <div className="SmeTableStyle">
                        <div className="SmeHeader">
                            <div className="SmeHeaderRow">
                                <SmeHeaderCell width="50%" align="left">
                                    Cover
                                </SmeHeaderCell>
                                <SmeHeaderCell width="40%" align="left">
                                    Sum Insured / limits (SGD)
                                </SmeHeaderCell>
                                <SmeHeaderCell width="10%">
                                </SmeHeaderCell>
                            </div>
                        </div>
                        <div className="SmeBody">
                            <div className="SmeRow" onClick={() => toggleStatus('propertyAllRisksInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Property All Risks
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    {(_formatAmount((Number(props.policy.policySME.contentsSI) + Number(props.policy.policySME.buildingSI)), i18n.language, t("currency.prefix"))) || '$50,000.00'}
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.propertyAllRisksInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.propertyAllRisksInd &&
                                    <React.Fragment>
                                        <SmeCell width="100%" small="true" space="up">
                                            <Link className="QuoteSummaryLink" onClick={openCoverInformation}>Additional Cover Information</Link>
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            Excess
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            $100
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="SmeRow" onClick={() => toggleStatus('businessInterruptionInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Business Interruption
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    $1,400
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.businessInterruptionInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.businessInterruptionInd &&
                                    <React.Fragment>
                                        <SmeCell width="50%" small="true" space="up">
                                            Basis of Cover
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            Weekly Benefits
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            Indemnity Period (Weeks)
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            14
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            Weekly Benefit Value
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            $1,400
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="SmeRow" onClick={() => toggleStatus('moneyInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Money
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    $5,000
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.moneyInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.moneyInd &&
                                    <React.Fragment>
                                        <SmeCell width="50%" small="true" space="up">
                                            Money in Transit
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            $5,000
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            In Premises During Business Hours
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            $5,000
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            In Premises Outside Business Hours
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            $5,000
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="SmeRow" onClick={() => toggleStatus('groupPersonalAccidentInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Group Personal Accident
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    $30,000
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.groupPersonalAccidentInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.groupPersonalAccidentInd &&
                                    <React.Fragment>
                                        <SmeCell width="50%" small="true" space="up">
                                            Type of Cover
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            1 Registered proprietor/ partner / director
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            Death and Permanent Disablement
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            $30,000
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="SmeRow" onClick={() => toggleStatus('liabilityInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Public Liability
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    $5,000,000
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.liabilityInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.liabilityInd &&
                                    <React.Fragment>
                                        <SmeCell width="50%" small="true" space="up">
                                            Type of Cover
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            Public Liability
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="SmeRow" onClick={() => toggleStatus('workInjuryCompensationInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Work Injury Compensation
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    {/* SME-4198 Hide WICA Common Law Limit - originally $15,000,000.00*/}
                                    &nbsp;
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.workInjuryCompensationInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.workInjuryCompensationInd &&
                                    <React.Fragment>
                                        <SmeCell width="50%" small="true" space="up">
                                            No of Employee
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            {(props.policy.policySME.numberOfEmployees) || '12'}
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="up">
                                            Total Estimated Earnings
                                        </SmeCell>
                                        < SmeCell width="50%" small="true">
                                            {(_formatAmount(props.policy.policySME.annualWages, i18n.language, t("currency.prefix"))) || '$1,000,000'}
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="SmeRow" onClick={() => toggleStatus('fidelityGuaranteeInd')}>
                                <SmeCell width="50%" bold="true" mbold="true">
                                    Fidelity Guarantee
                                </SmeCell>
                                <SmeCell width="40%" mbold="true">
                                    $5,000
                                </SmeCell>
                                <SmeCell width="10%" align="center">
                                    <img src={ind.fidelityGuaranteeInd ? Up : Down} />
                                </SmeCell>
                                {
                                    ind.fidelityGuaranteeInd &&
                                    <React.Fragment>
                                        <SmeCell width="50%" small="true" space="up">
                                            Type of Cover
                                        </SmeCell>
                                        <SmeCell width="50%" small="true" space="down">
                                            Retail / Office Employees Staff handling money and/or goods
                                        </SmeCell>
                                    </React.Fragment>
                                }
                            </div>

                            <div className="QuoteSummaryFooter">
                                <Link className="QuoteSummaryLink" onClick={openCustomisation}>Click here</Link> for customized package designed specifically to cater your needs.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="QuoteSummaryInputButtonsGroupStyle">
                <div className="QuoteSummaryInputButtonsStyle">
                    <Button color="primary" onClick={applyNow}>Apply Now</Button>
                </div>
            </div>
        </Template>
    );
}

// get status from redux (subscription)
const mapStateToProps = (state) => {
    return {
        step: _getStep(state),
        policy: _getPolicy(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    setStep: _setStep,
    showModal: _showModal,
    hideModal: _hideModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuoteSummary));

